<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const readIssue = () => JSON.parse(localStorage.getItem('tc-claim-issue'))

const readClaim = () => JSON.parse(localStorage.getItem('tc-claim-success'))
const readCompensation = () => JSON.parse(localStorage.getItem('tc-claim-compensation'))

const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToContinue = () => {
  location.replace('#/claim/details')
}
//endregion
//region Variables
const data = reactive(readData())
const issue = reactive(readIssue())
const claim = reactive(readClaim())
const claimId = ref(claim?.claimId)
const items = reactive(readSelectedItems())
const compensation = reactive(readCompensation())
const orderNumber = ref(data?.orderNumber ?? '')
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})
//endregion
</script>

<template>

  <header class="bg-tc-off-white-two overflow-hidden flex items-center justify-center h-[280px]">
    <div class="relative min-w-[171px] h-[171px]">
      <img :src="items[0]?.image" class="w-[143px] shadow z-50 absolute top-0 right-0" alt="image"/>
      <div v-if="items.length > 1">
        <span class="absolute bg-black rounded-full text-white text-tc-subtitle font-medium font-avenir w-[27px] h-[27px] flex justify-center items-center z-50 -top-1.5 -right-1.5"
              v-text="items.length"></span>
        <img :src="items[1]?.image ?? items[0]?.image" class="w-[143px] shadow z-20 absolute top-2 right-2" alt="image"/>
        <img v-if="items.length > 2" :src="items[2]?.image ?? items[0]?.image"
             class="w-[143px] shadow z-10 absolute top-4 right-4" alt="image"/>
      </div>
    </div>
  </header>

  <main class="mx-auto px-[20px] mt-[18px] lg:px-[40px] lg:mx-0 lg:max-w-[40%]">

    <figure class="flex flex-row items-center gap-3 mb-[20px]">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
        <circle cx="6.5" cy="6.5" r="6" stroke="#CCC2B3"/>
        <path d="M6.5 2V7L8.5 9" stroke="#CCC2B3"/>
      </svg>
      <span class="text-tc-xl text-tc-maroon font-avenir font-normal tracking-wide">In Review - #{{ claimId }}</span>
    </figure>

    <p class="text-tc-xl text-tc-maroon font-avenir font-normal leading-normal tracking-wide mb-[30px]"
    >We are actively reviewing your issue, and will provide an update as soon as our review is complete.</p>

    <h3 class="text-tc-xl text-tc-maroon font-avenir font-normal tracking-wide mb-[20px]">Claim Details</h3>

    <ul class="grid grid-cols-1 gap-[20px]">

      <li v-if="issue?.title">
        <h2 class="text-tc-muted-brown font-avenir text-tc-lg font-medium mb-[8px]">Issue Reported</h2>
        <p class="text-black-brown font-avenir text-tc-xl font-medium mb-[8px]" v-text="issue?.title"></p>
        <hr class="bg-tc-off-white-two mt-[20px]">
      </li>

      <li v-if="issue?.customerNotes">
        <h2 class="text-tc-muted-brown font-avenir text-tc-lg font-medium mb-[8px]">Additional Details</h2>
        <p class="text-black-brown font-avenir text-tc-xl font-medium mb-[8px]" v-text="issue?.customerNotes"></p>
        <hr class="bg-tc-off-white-two mt-[20px]">
      </li>

      <li v-if="compensation?.title && issue.key !== 'other'">
        <h2 class="text-tc-muted-brown font-avenir text-tc-lg font-medium mb-[8px]">Compensation</h2>
        <p class="text-black-brown font-avenir text-tc-xl font-medium mb-[8px]" v-text="compensation?.title"></p>
        <hr class="bg-tc-off-white-two mt-[20px]">
      </li>

    </ul>

    <h3 class="mb-[12px] flex items-center gap-3 mt-[20px]">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path d="M8.053 6.916H9.067V13H8.053V6.916ZM7.819 4.537C7.819 4.33767 7.88833 4.16433 8.027 4.017C8.17433 3.86967 8.352 3.796 8.56 3.796C8.768 3.796 8.94133 3.86967 9.08 4.017C9.22733 4.16433 9.301 4.33767 9.301 4.537C9.301 4.75367 9.23167 4.93133 9.093 5.07C8.95433 5.20867 8.77667 5.278 8.56 5.278C8.34333 5.278 8.16567 5.20867 8.027 5.07C7.88833 4.93133 7.819 4.75367 7.819 4.537Z" fill="#2E1319"/>
        <rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#2E1319"/>
      </svg>
      <span class="text-tc-xl text-tc-muted-brown font-medium">Support</span>
    </h3>

    <ul class="grid grid-cols-1 gap-[12px] lg:mb-[30px]">
      <li><a href="https://help.trescolori.com" class="text-tc-lg underline" target="_blank">View Help Center</a></li>
      <li><a href="mailto:info@trescolori.com" class="text-tc-lg underline" target="_blank">info@trescolori.com</a></li>
    </ul>

  </main>

</template>

<style scoped>
</style>